module.exports = __webpack_public_path__ + "img/user-8.a5e9c1f0.png";